const Unauthorized = () => {
    return (<div className="w-full h-80 py-5 flex justify-center items-center">
        <h1 className="text-xl mx-3">Access Denied: You are not authorized to access this page</h1>
    </div>);
}
 
export default Unauthorized;